import React from 'react';
import * as XLSX from 'xlsx';

const LaminationMachine = () => {
  const inspectionData = JSON.parse(sessionStorage.getItem('inspectionData') || '{}');
  const laminationData = inspectionData.LaminationMachine;

  if (!laminationData) {
    return <p className="text-gray-500">No Lamination Machine data available</p>;
  }

  // Function to download data as Excel
  const downloadExcel = () => {
    const workbook = XLSX.utils.book_new();
    const worksheetData = [];

    // Headers for the Excel sheet
    worksheetData.push([
      'Line',
      'Laminator',
      'Chamber 1 Temp',
      'Chamber 2 Temp',
      'Cooling Time',
      'Total Cycle Time',
      'Vacuum Time B1',
      'Vacuum Time B2',
      'Remarks',
    ]);

    // Populate data for each line and laminator
    Object.entries(laminationData).forEach(([lineKey, lineData]) => {
      Object.entries(lineData).forEach(([laminatorKey, laminator]) => {
        worksheetData.push([
          lineKey,
          laminatorKey,
          laminator.chamber1Temp,
          laminator.chamber2Temp,
          laminator.coolingTime,
          laminator.totalCycleTime,
          laminator.vacuumTimeB1,
          laminator.vacuumTimeB2,
          laminator.remarks,
        ]);
      });
    });

    const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
    XLSX.utils.book_append_sheet(workbook, worksheet, 'LaminationMachine');
    XLSX.writeFile(workbook, 'LaminationMachineData.xlsx');
  };

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-2xl font-semibold text-gray-800">Lamination Machine Data</h2>
        <button
          onClick={downloadExcel}
          className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 focus:outline-none"
        >
          Download Excel
        </button>
      </div>

      {Object.entries(laminationData).map(([lineKey, lineData]) => (
        <div key={lineKey} className="border-b pb-4">
          <h3 className="text-xl font-semibold text-gray-800 mb-4">{lineKey}</h3>

          {Object.entries(lineData).map(([laminatorKey, laminator]) => (
            <div key={laminatorKey} className="mt-4">
              <h4 className="font-semibold text-gray-700 mb-2">{laminatorKey}</h4>
              <div className="overflow-x-auto">
                <table className="min-w-full bg-white border rounded-lg">
                  <thead>
                    <tr className="bg-gray-100">
                      <th className="px-4 py-2 text-left text-gray-700">Chamber 1 Temp</th>
                      <th className="px-4 py-2 text-left text-gray-700">Chamber 2 Temp</th>
                      <th className="px-4 py-2 text-left text-gray-700">Cooling Time</th>
                      <th className="px-4 py-2 text-left text-gray-700">Total Cycle Time</th>
                      <th className="px-4 py-2 text-left text-gray-700">Vacuum Time B1</th>
                      <th className="px-4 py-2 text-left text-gray-700">Vacuum Time B2</th>
                      <th className="px-4 py-2 text-left text-gray-700">Remarks</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr className="border-t">
                      <td className="px-4 py-2 text-gray-600">{laminator.chamber1Temp || 'N/A'}</td>
                      <td className="px-4 py-2 text-gray-600">{laminator.chamber2Temp || 'N/A'}</td>
                      <td className="px-4 py-2 text-gray-600">{laminator.coolingTime || 'N/A'}</td>
                      <td className="px-4 py-2 text-gray-600">{laminator.totalCycleTime || 'N/A'}</td>
                      <td className="px-4 py-2 text-gray-600">{laminator.vacuumTimeB1 || 'N/A'}</td>
                      <td className="px-4 py-2 text-gray-600">{laminator.vacuumTimeB2 || 'N/A'}</td>
                      <td className="px-4 py-2 text-gray-600">{laminator.remarks || 'N/A'}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};

export default LaminationMachine;